import { Pipe, PipeTransform } from '@angular/core';
import { Column } from '../../../interfaces';

@Pipe({
  name: 'hideBorderBottom',
  standalone: true,
})
export class HideBorderBottomPipe implements PipeTransform {
  transform(columns: Column[], hideBottomBorder: boolean): unknown {
    return 'subTable' in columns[0] || hideBottomBorder;
  }
}
